"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getUserDefinedNodeType(type, userDefinedNodeId) {
  return type + "-" + userDefinedNodeId;
}
exports.getUserDefinedNodeType = getUserDefinedNodeType;
//# sourceMappingURL=extendedTypes.js.map
